/** Word-level diff (LCS) for proposal cards: removed red, added green. Tokens keep their trailing whitespace. */
export type DiffOp = { type: "same" | "add" | "del"; text: string };

const tokens = (s: string) => s.match(/\S+\s*|\s+/g) ?? [];

export function wordDiff(before: string, after: string): DiffOp[] {
  const a = tokens(before), b = tokens(after);
  const n = a.length, m = b.length;
  // LCS table (n+1)*(m+1); texts are a few hundred words, so this stays cheap
  const dp: Uint32Array[] = Array.from({ length: n + 1 }, () => new Uint32Array(m + 1));
  for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--) dp[i]![j] = a[i] === b[j] ? dp[i + 1]![j + 1]! + 1 : Math.max(dp[i + 1]![j]!, dp[i]![j + 1]!);
  const out: DiffOp[] = [];
  const push = (type: DiffOp["type"], text: string) => { const last = out[out.length - 1]; if (last && last.type === type) last.text += text; else out.push({ type, text }); };
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) { push("same", a[i]!); i++; j++; }
    else if (dp[i + 1]![j]! >= dp[i]![j + 1]!) { push("del", a[i]!); i++; }
    else { push("add", b[j]!); j++; }
  }
  while (i < n) push("del", a[i++]!);
  while (j < m) push("add", b[j++]!);
  return out;
}
